<div class="form-horizontal" [formGroup]="samplingNeeds">
  <div class ="col-sm-6">
    <div class="form-group row" [class.has-error]="assay.invalid">
      <label class="control-label col-sm-5">Assay Type</label>
      <span class="col-sm-7">
        <select formControlName="assay" class="form-control">
          <option [ngValue]="null"></option>
          <option *ngFor="let option of assays" [ngValue]="option.id">{{ option.display }}</option>
        </select>
      </span>
    </div>

    <div class="form-group row" [class.has-error]="tissueType.invalid">
      <label class="control-label col-sm-5">Tissue Type</label>
      <span class="col-sm-7">
        <select formControlName="tissueType" class="form-control">
          <option [ngValue]="null"></option>
          <option *ngFor="let option of tissueTypes" [ngValue]="option.id">{{ option.display }}</option>
        </select>
      </span>
    </div>

    <div class="form-group row" *ngIf="displayTissueCollectionType" [class.has-error]="tissueCollectionType.invalid">
      <label class="control-label col-sm-5">Tissue Collection</label>
      <span class="col-sm-7">
        <select formControlName="tissueCollectionType" class="form-control">
          <option *ngFor="let option of filteredTissueCollectionTypes" [ngValue]="option.id">{{ option.display }}</option>
        </select>
      </span>
    </div>
  </div>
    
  <div class="col-sm-6" *ngIf="displaySamplingDateCalculationFields">
    <div class="form-group row" [class.has-error]="growthStage.invalid">
      <div class="col-sm-5">
        <label class="radio-inline">
          <input type="radio" [value]="GROWTH_STAGE" formControlName="samplingDateCalculationStrategy">
          Growth Stage
        </label>
      </div>
      
      <div class="col-sm-7">
        <select formControlName="growthStage" class="form-control">
          <option [ngValue]="null"></option>
          <option *ngFor="let option of growthStages" [ngValue]="option.id">{{ option.display }}</option>
        </select>
      </div>
    </div>

    <div class="form-group row" [class.has-error]="daysAfterPlanting.invalid">
      <div class="col-sm-5">
        <label class="radio-inline">
          <input type="radio" [value]="DAYS_AFTER_PLANTING" formControlName="samplingDateCalculationStrategy">
          Days after Planting
        </label>
      </div>
      
      <div class="col-sm-7">
        <input type="number" class="form-control" formControlName="daysAfterPlanting" appIntegerValueAccessor/>
        <small *ngIf="displaySamplingDate" class="form-text text-muted text-right">{{ samplingDate | date: 'MMMM d, y' }}</small>
      </div>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/request-creation/experiment-design/sampling-needs/sampling-needs-form/sampling-needs-form.component.html